import React from "react";
import "../custom.css";

export default function About() {
  return <div className="top-margin">This is About</div>;
}
